import { event } from "../content";

export function Event() {
  if (!event) return null;

  return (
    <section aria-label="Upcoming event" className="bg-stab px-4 py-6 text-ink md:px-8">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-baseline gap-x-8 gap-y-2 md:grid-cols-12">
        <p className="font-display text-2xl font-extrabold uppercase leading-none tracking-tight md:col-span-5 md:text-3xl">
          {event.name}
        </p>
        <p className="font-medium md:col-span-3">{event.dates}</p>
        <p className="font-medium md:col-span-4 md:text-right">
          {event.venue}, {event.stand}
        </p>
      </div>
    </section>
  );
}
